var _g, _path, _path2, _path3, _g2, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_133_1330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.934 12.973C47.2714 10.0059 47.4402 8.52235 46.9916 7.3234C46.5971 6.26877 45.8788 5.36612 44.9397 4.74481C43.8721 4.03848 42.3886 3.86975 39.4215 3.53229L34.4263 2.96417C31.4592 2.6267 29.9757 2.45797 28.7767 2.90651C27.7221 3.30106 26.8195 4.01935 26.1982 4.95844C25.4918 6.02605 25.3231 7.50959 24.9856 10.4767L24.4175 15.4718C24.0801 18.4389 23.9113 19.9225 24.3599 21.1214C24.7544 22.176 25.4727 23.0787 26.4118 23.7C27.4794 24.4063 28.9629 24.575 31.93 24.9125L36.9252 25.4806C39.8923 25.8181 41.3758 25.9868 42.5748 25.5383C43.6294 25.1437 44.532 24.4254 45.1533 23.4864C45.8597 22.4188 46.0284 20.9352 46.3659 17.9681L46.934 12.973Z",
    fill: "#4D54C1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1935 12.5022C46.4877 9.91613 46.6347 8.62309 46.2354 7.58072C45.8989 6.70233 45.2996 5.94917 44.5192 5.424C43.5931 4.8008 42.3001 4.65374 39.714 4.35961L33.9555 3.70467C31.3694 3.41054 30.0764 3.26347 29.034 3.66279C28.1556 3.9993 27.4025 4.59864 26.8773 5.37902C26.2541 6.30509 26.1071 7.59813 25.8129 10.1842L25.2903 14.7795C24.9961 17.3656 24.8491 18.6586 25.2484 19.701C25.5849 20.5794 26.1842 21.3326 26.9646 21.8577C27.8907 22.4809 29.1837 22.628 31.7698 22.9221L37.5283 23.577C40.1144 23.8712 41.4074 24.0182 42.4498 23.6189C43.3282 23.2824 44.0813 22.6831 44.6065 21.9027C45.2297 20.9766 45.3768 19.6836 45.6709 17.0975L46.1935 12.5022Z",
    fill: "#5F67EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4185 19.2504C40.0445 13.7464 31.5677 12.4339 30.9026 18.2818",
    stroke: "#FDFBF7",
    strokeWidth: 0.857081,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8837 9.25792L37.5765 11.9592M34.6422 8.88924L34.335 11.5905",
    stroke: "#FDFBF7",
    strokeWidth: 1.26637,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_133_1330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0593 22.2449C34.805 18.9251 34.6779 17.2652 33.9347 16.0466C33.281 14.9748 32.3047 14.1374 31.1458 13.6545C29.8284 13.1055 28.1684 13.2327 24.8486 13.4869L11.4844 14.5104C8.16453 14.7646 6.50462 14.8917 5.28609 15.6349C4.21425 16.2886 3.37687 17.2649 2.89398 18.4238C2.345 19.7413 2.47212 21.4012 2.72636 24.721L3.74982 38.0853C4.00406 41.4051 4.13118 43.065 4.87437 44.2835C5.52809 45.3554 6.50436 46.1928 7.66325 46.6757C8.98074 47.2246 10.6406 47.0975 13.9605 46.8433L27.3247 45.8198C30.6446 45.5656 32.3045 45.4385 33.523 44.6953C34.5948 44.0415 35.4322 43.0653 35.9151 41.9064C36.4641 40.5889 36.337 38.929 36.0827 35.6092L35.0593 22.2449Z",
    fill: "#BF8333"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8646 21.8122C33.6531 19.0502 33.5473 17.6692 32.9208 16.6599C32.3928 15.8093 31.6153 15.1424 30.6942 14.7501C29.6012 14.2845 28.2202 14.3903 25.4582 14.6018L11.0516 15.7051C8.28962 15.9166 6.90862 16.0224 5.89927 16.6489C5.0487 17.1769 4.38176 17.9545 3.98945 18.8755C3.52392 19.9685 3.62968 21.3495 3.8412 24.1115L4.81326 36.8046C5.02478 39.5666 5.13054 40.9476 5.75707 41.9569C6.28505 42.8075 7.06262 43.4745 7.98366 43.8668C9.07665 44.3323 10.4576 44.2265 13.2196 44.015L27.6263 42.9117C30.3883 42.7002 31.7693 42.5945 32.7786 41.9679C33.6292 41.4399 34.2961 40.6624 34.6884 39.7413C35.154 38.6483 35.0482 37.2674 34.8367 34.5054L33.8646 21.8122Z",
    fill: "#FFB63E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7135 29.2173C27.4398 38.7011 12.8117 40.4175 12.04 30.341",
    stroke: "#FDFBF7",
    strokeWidth: 1.47165,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0721 23.0075L21.3531 26.6759M16.6701 23.3446L16.951 27.013",
    stroke: "#FDFBF7",
    strokeWidth: 1.71375,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_133_1330",
    x: 22.4474,
    y: 0.994009,
    width: 25.988,
    height: 25.988,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.234375,
    dy: -0.234375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.703125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.241667 0 0 0 0 0.170598 0 0 0 0 0.0916319 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_133_1330"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_133_1330",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_133_1330",
    x: 0.985336,
    y: 11.7459,
    width: 36.604,
    height: 36.604,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.117188,
    dy: -0.117188
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.703125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_133_1330"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_133_1330",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.55c1c8b222a0fe97c00c626e266caf28.svg";
export { ForwardRef as ReactComponent };